export default {
  personalDetails: 'Personal details',
  workExperience: 'Work experience',
  preference: 'Preference',
  viewFile: 'Your uploaded file',
  jobProfile: 'Job Profile',
  fields: {
    name: 'Full Name *',
    gender: 'What is your gender? *',
    qualification: 'What is your highest qualification? *',
    specialisation: 'What is your specialisation?',
    resume: 'Do you have a resume?',
    experience: 'How long were you working *',
    pastEmployer: 'Your past employer?',
    designation: 'Your recent designation?',
    salary: 'Your recent salary?',
    jobCategory: 'What kind of job are you looking for *',
    preferredLocation: 'Your preferred location? *',
    jobType: 'Your preferred job type *',
    workType: 'Your preferred work type *',
    shiftTiming: 'Your preferred work time *'
  },
  uploadResume: 'Upload your resume',
  uploadText: 'You can upload a .jpg, .pdf or a word doc. OR take a picture',
  optional: 'Optional',
  placeholders: {
    name: 'Provide your full name for recruiters',
    specialisation: 'eg: Engineering, Arts',
    pastEmployer: 'eg: TCS, Wipro',
    designation: 'eg: Sales Manager',
    salary: 'Choose a salary range',
    jobCategory: 'Choose job categories',
    preferredLocation: 'Select multiple districts',
    searchForJobs: 'Search for jobs',
    signUp: 'Signup'
  },
  buttons: {
    uploadResume: 'Upload resume',
    capture: 'Take a picture',
    uploadFromDevice: 'Upload from device',
    next: 'Next',
    submit: 'Submit',
    done: 'Done',
    viewFile: 'View File',
    delete: 'Delete',
    change: 'Change',
    pause: 'Pause',
    retry: 'Retry'
  },
  allStates: 'Anywhere in {state}',
  jobCategory: 'Job Category',
  preferredLocation: 'Preferred Location',
  salary: 'Choose Salary Range',
  resume: 'Resume',
  recommendedJobs: 'Recommended jobs',
  sponsoredJobs: 'Sponsored jobs',
  footerFields: {
    CustomerServices: 'Customer Services',
    emailUs: 'Email us',
    privacyPolicy: 'Privacy Policy',
    termsAndConditions: 'Terms and conditions',
    needJob: 'Need a job near you?',
    jobs: '1 lakh jobs',
    sections: '40 sections'
  },
  emptyResultsScreenFields: {
    jobsByCategories: 'Jobs by Categories',
    jobsByLocation: 'Jobs by Location',
    headerMessage1: 'Sorry, we could not find any open roles for your search',
    headerMessage2: 'Signup for Job alerts and we’ll notify you when new jobs have opened up',
    explore: 'Explore jobs by categories and location',
    noOfJobs: '10 jobs',
    icon: 'icon'
  },
  exploreJobsFiltersFields: {
    Category: 'Category',
    salaryRange: 'Salary Range',
    Experience: 'Experience',
    exploreJobsHero: 'Explore by job categories'
  },
  faqFields: {
    header: 'Frequently asked questions'
  },
  homePageHeroFields: {
    findDreamJob: 'Find your dream job!',
    availableJobsAndNoOfCities: ' 50 Lakh+ Jobs | 70+ Cities',
    content: 'Apply for jobs on Lokalapp & talk to the HRs of the companies directly.'
  },
  appalyForJob: 'Apply for a Job',
  searchJob: 'Search job',
  postAJob: 'Post A job',
  jobFindingStepsFields: {
    step1: '1. Create your job Profile',
    step2: '2. Find a job vacancy',
    step3: '3. Contact the HR directly to Apply',
    hero: 'Find your dream job using Lokal in 3 simple steps:'
  },
  jobSearchPlaceHolder: 'Search for jobs',
  share: 'Share',
  shareOnWhatsApp: 'Share on WhatsApp',
  report: 'Report',
  viewJobs: 'View jobs',
  lookingForJobHero: {
    hero: 'Looking for a job?',
    content: 'The sky was cloudless and had a deep blue hue.'
  },
  postNewJobFields: {
    hero: 'Post your work Local application in 3 simple steps:',
    content1: 'Target job advertising from 250+ districts',
    content2: 'Recruit from 1 lakh eligible candidates',
    content3: 'Get maximum responses at low rates'
  },
  quickAccessFooterFields: {
    quickLinks: 'Quick Links',
    categoryWiseJobs: 'Category wise jobs',
    jobsByLocation: 'Jobs by location',
    viewAllCategories: 'View all categories',
    viewAllLocations: 'View all locations'
  },
  jobSearchPlaceHolder1: 'Enter Job title, keyword,...',
  warangal: 'warangal',
  krishna: 'krishna',
  vishakapatnam: 'Vishakapatnam',
  yadadri: 'yadadri',
  guntur: 'guntur',
  jobs: 'Jobs',
  seeAll: 'See all',
  jobListing: 'Job Listing',
  findAJob: 'Find a job',
  createAnAccount: 'Create an account',
  jobSearchAdvice: 'Job Search Advice',
  administration: 'Administration',
  digitalMarketing: 'Digital Marketing',
  design: 'Design',
  development: 'Development',
  productmanagement: 'Product management',
  finance: 'Finance',
  agra: 'Agra',
  bengaluru: 'Bengaluru',
  delhi: 'Delhi',
  mumbai: 'Mumbai',
  hi: 'Hi',
  home: 'Home',
  exploreJobs: 'Explore Jobs',
  postAJob: 'Post a Job',
  contactUs: 'Contact Us',
  contact: 'contact',
  getTheApp: 'Get the App',
  loginOrCreateAnAccount: 'Login or Create an account',
  login: 'Login',
  createYourProfile: 'Create profile',
  editProfile: 'Edit Profile',
  myProfile: 'My Profile',
  logOut: 'Log Out',
  disclosureTitle: {
    jobDetails: 'Job Details',
    feesRequired: 'Fees Required',
    noFeeIsRequired: 'No fee is required'
  },
  whyIsItNeeded: 'Why is it needed',
  emailUsOn: 'email us on',
  similarJobs: 'Similar Jobs',
  noSimilarJobs: 'No similar Jobs',
  loading: 'Loading',
  enterNewMobileNumber: 'Enter new mobile number',
  mobileNumber: 'Mobile Number',
  anOtpWillBeSentToThisNumber: 'An OTP will be sent to this number',
  welcomeToLokal: 'Welcome to Lokal',
  loginOrSignup: 'Login or Signup',
  otpDiscription:
    'Enter the mobile number you wish to be contacted on. An OTP will be sent to this number',
  iAgreeToThe: 'I agree to the',
  and: 'and',
  yesApply: 'Yes,apply',
  termsAndConditions: 'Terms & Conditions',
  privacyPolicy: 'Privacy Policy',
  continue: 'Continue',
  checkYourSms: 'Check your SMS',
  weHaveSentYouAnOtpOn: 'We have sent you an OTP on',
  changeNumber: 'Change Number',
  enterFourDigitOtp: 'Enter 4 digit OTP',
  didNotRecieveTheOtp: 'Did not receive the OTP',
  otpCheckBoxDiscription: 'I would like to receive WhatsApp notifications',
  done: 'Done',
  incorrectCredentials: 'Incorrect credentials',
  resendOtp: 'Resend OTP',
  resendOtpIn: 'Resend OTP in',
  noResultsFoundFor: 'No results found for',
  jobsTitle: 'Jobs in {location} | Find Job Vacancies in {location} : {host}/jobs',
  jobsMetaData:
    'Apply for Jobs in {location} on {host}/jobs. Register for Free & Find Job Openings in {location}',
  posted: 'Posted',
  ago: 'ago',
  views: 'views',
  cancel: ' cancel',
  pleaseTryAgain: 'Please try again',
  locationsNotAvailable: 'Locations not available',
  jobsByCategories: 'Jobs by category',
  footerModelForApplyJobFields: {
    header1: 'Are you sure want to continue',
    header2: 'Job Application has been succesfully Submitted',
    applyConformation: 'applying for this job?',
    subText1: 'if selected,you will receive a call from the recuiter',
    subText2: 'Your details will be sent to the recruiter'
  },
  advertiser: {
    whatOurUsersSay: 'What our employers have to say about Lokal'
  },
  searchJobs: 'Search Jobs',
  createFreeAccount: 'Create free account',
  jobAdvice: 'Job Advice',
  postAJob: 'Post a Job',
  mobileNumber: 'Mobile Number',
  sendOTP: 'Send OTP',
  verifyOTP: 'Verify OTP',
  downLoadApp: 'Download the app',
  jobsNearMeTitle: '{numberOfJobs} Job Openings & Vacancies  - Find the Perfect Job',
  jobsDescription:
    'Searching for jobs in {Location}? Find the latest openings and vacancies in {Location} in 2023 with Lokal Job Listings',
  postJobSteps: {
    jobDetail: 'ఉద్యోగ వివరాలు',
    aboutJob: 'ఉద్యోగం గురించి',
    selectRole: 'ఉద్యోగ పాత్రను ఎంచుకోండి',
    selectTitle: 'జాబ్ టైటిల్ సెలెక్ట్ చేయండి',
    postTitle: 'పోస్ట్ శీర్షికను నమోదు చేయండి',
    sampleJobTypes: 'ఉదా. సేల్స్ అకౌంటెంట్, డెలివరీ బాయ్ మొదలైనవి',
    addJobDescription: 'ఉద్యోగ వివరణను జోడించండి',
    removeJobDescription: 'ఉద్యోగ వివరణను తీసివేయండి',
    NoOfOpenings: 'ఓపెనింగ్‌ల సంఖ్య',
    enterNoOfOpenings: 'ఓపెనింగ్‌ల సంఖ్యను నమోదు చేయండి',
    monthlyIncome: 'నెలవారీ ఆదాయం',
    enterMinSalary: 'కనిష్ట జీతం నమోదు చేయండి',
    enterMaxSalary: 'గరిష్ట జీతం నమోదు చేయండి',
    jobShift: 'ఉద్యోగ మార్పు',
    dayShift: 'రోజు షిఫ్ట్',
    nightShift: 'రాత్రి పని',
    anyShift: 'ఏదైనా షిఫ్ట్',
    jobType: 'ఉద్యోగ రకము',
    fieldJob: 'ఫీల్డ్ జాబ్',
    officeJob: 'ఆఫీసు ఉద్యోగం',
    workFromHome: 'ఇంటి నుండి పని చేయండి',
    industryJob: 'పరిశ్రమ ఉద్యోగం',
    officeLocation: 'కార్యాలయం స్థానం',
    interstedPlace: 'మీరు ఎక్కడ నుండి నియామకం చేయడానికి ఆసక్తి కలిగి ఉన్నారు?',
    district: 'జిల్లా',
    selectMultipleDistricts: 'బహుళ జిల్లాలను ఎంచుకోండి',
    charges: 'ఈ ఉద్యోగం కోసం, మీరు అభ్యర్థుల నుండి ఏదైనా రుసుము వసూలు చేస్తారా',
    yes: 'అవును',
    no: 'లేదు',
    reasonForFee:
      'దయచేసి నిజమైన కారణాల వల్ల ఫీజు వసూలు చేయబడిందని నిర్ధారించుకోండి మరియు ఫీజు కారణాన్ని అభ్యర్థికి స్పష్టంగా తెలియజేయండి',
    feeAmount: 'రుసుము మొత్తం (రూపాయిలలో)',
    selectReasonsForFee: 'ఫీజు కోసం కారణాలను ఎంచుకోండి',
    registrationFee: 'రిజిస్ట్రేషన్ ఫీజు',
    trainingFee: 'శిక్షణ రుసుము',
    feeForOtherReasons: 'యూనిఫారాలు, పరికరాలు, ఉపకరణాలు మొదలైన వాటికి రుసుము.',
    securityDeposit: 'ముందస్తుగా రక్షణకై జమ చేసుకొనే రొక్కము',
    commission: 'కమిషన్',
    otherReason: 'వేరే కారణం',
    specifyOtherReason: 'ఇతర కారణాన్ని పేర్కొనండి (ఏదైనా ఉంటే)',
    feeDueDate: 'ఫీజు ఎప్పుడు చెల్లించాలి',
    afterGivingJob: '"ఉద్యోగం ఇచ్చిన తర్వాత',
    beforeGivingJob: 'ఉద్యోగం ఇచ్చే ముందు',
    candidateRequirement: 'అభ్యర్థి అవసరం',
    candidateQualification: 'అభ్యర్థి అర్హత',
    selectMinimumEducation: 'కనీస విద్యను ఎంచుకోండి',
    selectYourExperience: 'సంవత్సరాల అనుభవాన్ని ఎంచుకోండి',
    preferredGender: 'ఇష్టపడే లింగం',
    male: 'పురుషుడు',
    female: 'స్త్రీ',
    anyGender: 'ఏదైనా లింగం',
    contactCandidatesThrough: 'ద్వారా అభ్యర్థులను నిర్వహించండి',
    callOnWhatsapp: 'కాల్స్ మరియు వాట్సాప్',
    callOnly: 'కాల్స్ మాత్రమే',
    whatsappNo: 'వాట్సాప్ నంబర్ అదే',
    next: 'తరువాత',
    companyDetail: 'కంపెనీ వివరాలు',
    selectCompanyType: 'మీ కంపెనీ రకాన్ని ఎంచుకోండి',
    consultancy: 'కన్సల్టెన్సీ / మ్యాన్‌పవర్ సంస్థ',
    hiresThirdPartyCompany: 'నేను థర్డ్ పార్టీ కంపెనీల కోసం నియమించుకుంటాను',
    company: 'కంపెనీ',
    hireForMyComapny: 'నేను నా కంపెనీ / స్టోర్ కోసం అద్దెకు తీసుకుంటాను',
    company: 'కంపెనీ',
    companyname: 'కంపెనీ పేరు నమోదు చేయండి',
    companySize: 'కంపెనీ పరిమాణం',
    largeScale: 'పెద్ద స్థాయి [50+ ఉద్యోగులు]',
    midScale: 'మధ్య స్థాయి [20-50 ఉద్యోగులు]',
    smallScale: 'చిన్న స్థాయి [5-20 ఉద్యోగులు]',
    companyNameToBeDisplayed: 'ఈ ఉద్యోగం కోసం అభ్యర్థులకు కంపెనీ పేరు ప్రదర్శించబడుతుంది',
    consultancyName: 'కన్సల్టెన్సీ పేరు',
    otherThirdPartyname: 'ఇతర మూడవ పార్టీ కంపెనీ పేరు',
    jobDescriptionPlaceholder: 'ఉద్యోగుల బాధ్యతలేమిటి?',
    officeLocationCityPlaceholder: 'నగరం / పట్టణాన్ని శోధించండి',
    officeLocationAreaPlaceholder: 'ప్రాంతం / ఏరియా శోధించండి',
    noOptionsDropdown: 'ఆప్షన్‌ల కోసం టైప్ చేయండి',
    selectDistrict: 'జిల్లాను ఎంచుకోండి',
    selectDistricts: 'జిల్లాలను ఎంచుకోండి',
    noDistrictSelected: 'ఎంపిక చేయబడింది',
    whatsappNumber: 'వాట్సాప్ నంబర్',
    recruiterLogin: 'మీరు దీని నుండి రిక్రూటర్‌గా లాగిన్ అయ్యారు',
    advertiserTooltip: 'ఈ ఉద్యోగాన్ని చూసే అభ్యర్థులకు ఈ పేరు నియామక సంస్థగా ప్రదర్శించబడుతుంది.',
    consultancyManpowerFirm: 'Consultancy / Manpower firm',
    thirdPartyHire: 'I hire for third party companies',
    companyNew: 'Company',
    companyStore: 'I hire for my company / store',
    consultancyNameNew: 'కన్సల్టెన్సీ పేరును నమోదు చేయండి',
    choosePlan: 'ప్లాన్ ఎంచుకోండి',
    noFeeWarning: 'దయచేసి ఎలాంటి రుసుము వసూలు చేయకుండా చూసుకోండి. ఉద్యోగ పోస్టులను తొలగించే లేదా అభ్యర్థులను మోసం చేసే ప్రకటనదారులు/ కంపెనీలను బ్లాక్ చేసే హక్కు లోకల్ యాప్ కు ఉంది.',
    feePaidQuestion: 'ఫీజు ఎప్పుడు చెల్లించాలి? (ఐచ్ఛికం)',
    feePaidCaution: 'ఉద్యోగ పోస్టులను తొలగించే లేదా అభ్యర్థులను మోసం చేసే ప్రకటనదారులు/ కంపెనీలను బ్లాక్ చేసే హక్కు లోకల్ యాప్ కు ఉంది.',
    useCurrentLocation: 'ప్రస్తుత స్థానాన్ని ఉపయోగించండి',
    skillsRequired: 'అవసరమైన నైపుణ్యం',
    addOtherSkills: 'ఇతర నైపుణ్యాలను చేర్చండి',
    additionalSkills: 'అదనపు నైపుణ్యాలు',
    additionalSkillsMsg: 'మీరు గరిష్టంగా 3 అదనపు నైపుణ్యాలను జోడించవచ్చు',
    additionalSkillsPlaceholder: 'కామా ద్వారా వేరు చేయబడిన ఇతర నైపుణ్యాలను జోడించండి',
    perDistrictChargeOne: 'మీరు పెయిడ్ ప్లాన్ కొనుగోలు చేస్తే',
    perDistrictChargeTwo: 'జిల్లా ప్రాతిపదికన',
    perDistrictChargeThree: 'మీకు ఛార్జీలు వసూలు చేయబడతాయి',
    skillsSelectedPlaceholder: 'ఎంచుకున్న నైపుణ్యాలు',
    industryLocation: 'పరిశ్రమ స్థానం',
    fieldLocation: 'ఫీల్డ్ లొకేషన్',
    workFromHome: 'రిజిస్టర్డ్ ఆఫీస్ అడ్రస్',
    submit: 'సమర్పించు',
    tncOne: 'పూర్తి',
    tncTwo: 'నిబంధనలు & షరతులను',
    tncThree: 'చదవండి',
    courseTitle: 'Select Course/Certificate',
    minEducation: 'Minimum Education',
    selectCoursePlaceholder: 'Select Course Name',
    courseName: 'Course name',
    optional: 'optional',
    experience: 'Experience',
    postingLocationMessage: 'You will receive candidates from',
    postingLocationModalTitle: 'Select hiring location',
    postingLocationSearchPlaceHolder: 'Search cities',
    //commented till translations not provided
    // proceedToPaySubtext: 'We follow fair use and privacy rules. Breaking policies or fraud can lead to account suspension and loss of service fees.',
    // checkout: 'Checkout',
    // checkoutInfo: 'Review your order and proceed with payment to unlock your benefits.',
    // orderSummary: 'Order Summary'
  },
  postJobErrorStates: {
    noOptions: 'దయచేసి ఒక ఆప్షన్ ఎంచుకోండి',
    wrongValue: 'దయచేసి సరైన విలువను నమోదు చేయండి',
    noOpenings: 'దయచేసి ఓపెనింగ్ ల సంఖ్యను పేర్కొనండి',
    noMonthlySalary: 'దయచేసి నెలవారీ జీతం ఇవ్వండి.',
    lowMinSalary: 'దయచేసి కనీస వేతనం 1000 కంటే తక్కువగా ఉండేలా చూసుకోండి.',
    highMinSalary: 'కనీస నెల జీతం రూ.1,00,000 లోపు ఉండాలి.',
    noFeeAmount: 'దయచేసి రుసుము మొత్తాన్ని (ఇన్ ₹) నమోదు చేయండి',
    lowMaxSalary: 'గరిష్ట వేతనం 1000 కంటే తక్కువగా ఉండేలా చూసుకోండి.',
    highMaxSalary: 'గరిష్ట నెల జీతం రూ.1,00,000 లోపు ఉండాలి.',
    minGreaterMax: 'గరిష్ట వేతనం కనీస వేతనం కంటే ఎక్కువగా ఉండాలి.',
    noTextArea: 'దయచేసి టెక్స్ట్ ప్రాంతాన్ని నింపండి',
    noPhoneNumber: 'దయచేసి ఫోన్ నెంబరు నమోదు చేయండి',
    noConsultancyName: 'దయచేసి కన్సల్టెన్సీ పేరు నమోదు చేయండి',
    noCompanyName: 'దయచేసి కంపెనీ పేరు నమోదు చేయండి',
    noCompanyType: 'దయచేసి మీ కంపెనీ రకాన్ని ఎంచుకోండి',
    noDataFound: 'No Data Found'
  }
}
